import { Button } from '@bambi/component-library/src/components/Button/Button';

import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';

import { dispatcherSlice } from '../../dispatcher.slice';
import { RunBambiRunButtonPopover } from '../RunBambiRunButtonPopover';
import { useRunBambiRun } from './useRunBambiRun';

export function UnassignedTripsRunBambiRunSection() {
  const assignments = useAppSelector(
    (state) => state.dispatcher.dispatchResponse?.assignments
  );

  const selectedUnassignedTripIds = useAppSelector(
    (state) => state.dispatcher.selectedUnassignedTripIds
  );

  const modalToShow = useAppSelector(
    (state) => state.dispatcher.modals.modalToShow
  );

  const runBambiRunShouldMultiload = useAppSelector(
    (state) => state.dispatcher.runBambiRunShouldMultiload
  );
  const dispatch = useAppDispatch();

  const isAssignmentSelectionModalShown =
    modalToShow === 'rbrAssignmentSelection';

  const runBambiRun = useRunBambiRun();

  const getButtonText = () => {
    if (isAssignmentSelectionModalShown) {
      return 'Select Assignments to Continue';
    }

    if (runBambiRunShouldMultiload) {
      return '[Beta] Run Bambi Run Multiload';
    }

    return 'Run Bambi Run';
  };

  return (
    <div
      className={`flex flex-col items-center justify-center gap-2.5 rounded-[10px] bg-white py-2 px-5 text-center font-normal text-[rgba(51,51,51,1)] drop-shadow-lg`}
    >
      <div className="relative flex w-full items-center justify-between">
        <Button
          variant="primary"
          className="w-full flex-grow"
          dataTestId="run-bambi-run-button"
          onClick={() => {
            if (assignments && assignments.length === 1) {
              runBambiRun({
                // May need to think about adding toggle here instead of assignment selection if we
                // want users to use rbr to multiload with only a single assignment
                // Currently we just want to test rbr multiloading internally so still discussing ui
                shouldMultiload: runBambiRunShouldMultiload,
                tripIds: selectedUnassignedTripIds,
                // Automatically select the only assignment
                assignments: [assignments[0].id],
                mode: 'optimal',
              });
              return;
            }
            dispatch(dispatcherSlice.actions.onRunBambiRunButtonClick());
          }}
          disabled={isAssignmentSelectionModalShown}
        >
          <div className="text-center">{getButtonText()}</div>
        </Button>
        <RunBambiRunButtonPopover />
      </div>
    </div>
  );
}
